import { initSubRoutes } from '../../../../utils/router';

const RoutesListeEmployes = initSubRoutes({
    route: '/employes/liste/',
    subroutes: {},
    nom: 'Liste employés',
});

export default RoutesListeEmployes;
